import type { ReactNode } from "react"

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { cn } from "@/lib/utils"

type AuthCardProps = {
  children: ReactNode
  className?: string
  description: string
  eyebrow: string
  title: string
}

export function AuthCard({
  children,
  className,
  description,
  eyebrow,
  title,
}: AuthCardProps) {
  return (
    <Card className={cn("rounded-3xl border-border/80 shadow-xl shadow-black/5", className)}>
      <CardHeader className="text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-muted-foreground">
          {eyebrow}
        </p>
        <CardTitle className="text-xl">{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  )
}
